module.exports = __webpack_public_path__ + "img/Icon - Quiz Sessions.486e8207.svg";